import { useCallback, useEffect, useState } from 'react';
import type { DeclaracaoNaoAssociacao } from '../../types';
import { listarDeclaracoes } from '../services/declaracaoNaoAssociacao';

/**
 * Declarações de não associação da negociação. Fica no DetailLeftColumn (e não no
 * painel) porque a existência de uma declaração esconde outros botões lá: o
 * caminho do avalista e o "Reenviar para análise cadastral".
 *
 * `ativo` evita a consulta em negociação que não está em termo_reprovado.
 */
export function useDeclaracoesNaoAssociacao(negociacaoId: number, ativo: boolean) {
    const [declaracoes, setDeclaracoes] = useState<DeclaracaoNaoAssociacao[]>([]);
    const [carregando, setCarregando] = useState(false);
    const [versao, setVersao] = useState(0);

    useEffect(() => {
        if (!ativo) { setDeclaracoes([]); return; }
        let cancelado = false;
        setCarregando(true);
        listarDeclaracoes(negociacaoId)
            .then(lista => { if (!cancelado) setDeclaracoes(lista); })
            .catch(err => console.error('Erro ao carregar declarações de não associação:', err))
            .finally(() => { if (!cancelado) setCarregando(false); });
        return () => { cancelado = true; };
    }, [negociacaoId, ativo, versao]);

    const recarregar = useCallback(() => setVersao(v => v + 1), []);

    return { declaracoes, carregando, recarregar };
}
